import React,{useState,useRef,useEffect} from 'react'
import { useDispatch,useSelector } from 'react-redux';
import { fetchSearch, updateProfileSummary } from '../../../Redux/Actions/ProfileSteps';
import "./style.css";
import { RESET_SEARCH } from '../../../Redux/Actions/types';
import Multiselect from 'multiselect-react-dropdown';
const ProfileSummary = ({setCurrentStep}) => {

  const [formData, setFormData] = useState({});
  const [city,setCity]=useState("");
  const [state,setState]=useState("");
  const [isChanged, setIsChanged] = useState({});
    const [prefillData,setPrefillData] = useState({})
  const profileData = useSelector(s => s.ProfileSteps.profileData);
  const [skillsSearch, setSkillsSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");
  const [StateSearch, setStateSearch] = useState("");
  const [skillsResults, setSkillsResults] = useState([]);
  const kids = useSelector(state => state.dashboard.kids);
  const skillsSearchResults = useSelector(s => s.ProfileSteps.searchByField.skillSetList);
  const citySearchResults = useSelector(s => s.ProfileSteps.searchByField.homeCity);
  const stateSearchResults = useSelector(s => s.ProfileSteps.searchByField.nativeState);
  const [debouncedSkillsSearch, setDebouncedSkillsSearch] = useState("");
  const dispatch = useDispatch();
const stateRef = useRef(null);
const cityRef = useRef(null);

// Add useEffect to handle outside clicks
useEffect(() => {
  const handleClickOutside = (event) => {
    // Close state dropdown independently
    if (stateRef.current && 
        !stateRef.current.contains(event.target) && 
        stateSearchResults?.length > 0) {
      setStateSearch('');
      dispatch({ type: RESET_SEARCH });
    }
    
    // Close city dropdown independently  
    if (cityRef.current && 
        !cityRef.current.contains(event.target) && 
        citySearchResults?.length > 0) {
      setCitySearch('');
      dispatch({ type: RESET_SEARCH });
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [dispatch, stateSearchResults, citySearchResults]);

          const [debouncedCitySearch, setDebouncedCitySearch] = useState('');
          useEffect(() => {
              const handler = setTimeout(() => {
                  setDebouncedCitySearch(citySearch);
              }, 500);
      
              return () => {
                  clearTimeout(handler);
              };
          }, [citySearch]);
          useEffect(() => {
              const fetchData = async () => {
                              if (debouncedCitySearch.length >= 3) {
                                  try {
                                      await dispatch(fetchSearch({ search_type: "homeCity", search_char: debouncedCitySearch, context: "homeCity" }));
                                  } catch (error) {
                                      console.error("Failed to fetch locations:", error);
                                  }
                              }else{
                                  dispatch({ type: RESET_SEARCH })
                              }
                          };
      
              fetchData();
          }, [debouncedCitySearch, dispatch]);
          const [debouncedStateSearch, setDebouncedStateSearch] = useState('');
          useEffect(() => {
              const handler = setTimeout(() => {
                  setDebouncedStateSearch(StateSearch);
              }, 500);
      
              return () => {
                  clearTimeout(handler);
              };
          }, [StateSearch]);
          useEffect(() => {
              const fetchData = async () => {
                              if (debouncedStateSearch.length >= 3) {
                                  try {
                                      await dispatch(fetchSearch({ search_type: "nativeState", search_char: debouncedStateSearch, context: "nativeState" }));
                                  } catch (error) {
                                      console.error("Failed to fetch locations:", error);
                                  }
                              }else{
                                  dispatch({ type: RESET_SEARCH })
                              }
                          };
      
              fetchData();
          }, [debouncedStateSearch, dispatch]);
  useEffect(()=>{
setSkillsResults(skillsSearchResults)
  },[skillsSearchResults])
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSkillsSearch(skillsSearch), 500);
    return () => clearTimeout(t);
  }, [skillsSearch]);
  useEffect(() => {
  setPrefillData({
    ...profileData,
    skillSetList: typeof profileData.skills === "string"
      ? profileData.skills.split(", ").map(s => s.trim()).filter(Boolean)
      : Array.isArray(profileData.skills)
        ? profileData.skills
        : [],
  });
}, [profileData]);
  useEffect(() => {
    const run = async () => {
      if (debouncedSkillsSearch.length >= 3) {
        try {
          const action = await dispatch(fetchSearch({ search_type: "skillSetList", search_char: debouncedSkillsSearch, context: "skillSetList" }));
        } catch (err) {
          console.error("City search failed:", err);
          setSkillsResults([]);
        }
      } else {
        setSkillsResults([]);
      }
    };

    run();
  }, [debouncedSkillsSearch, dispatch]);
    const handleSkillsRemove = (selectedList, removedItem) => {
setFormData((prev) => ({ ...prev, skills: selectedList }));
};


const handleSaveAndNext = async() => {
  try{

  const hasData = formData && Object.keys(formData).length > 0;

  if (hasData) {
    const updatedFormData = {
      ...formData,
      kid_id: kids?.[0]?.id,
      skills: Array.isArray(formData.skills)
        ? formData.skills
            .map((s) => (typeof s === "string" ? s.trim() : String(s)))
            .filter(Boolean)
            .join(", ")
        : formData.skills,
    };

    await dispatch(updateProfileSummary(updatedFormData))
  } else {
  }
  setCurrentStep(6);
}catch(err){
  console.error("Error updating profile summary:", err);
}
};


const handleSkillsSelect = (selectedList) => {
setFormData((prev) => ({ ...prev, skills: selectedList }));
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setIsChanged((prev) => ({ ...prev, [name]: true }));
  };
  const initialFetch = async(type, context) => {
    try {await dispatch({ type: RESET_SEARCH})
            await dispatch(
              fetchSearch({
                search_type: type,
                search_char: "prominentdef",
                context: context,
              })
            );
          } catch (err) {
            console.error(" search failed:", err);
          }
  }
  return (
   <>
        <div className="container-fluid">
            <div className='col-md-8 offset-md-2 py-5'>
                <div className='form-bg'>
                    <div className='form-group'>
                        <label htmlFor="">Profile Heading <strong class="fw-normal">(character limit :200)</strong></label>
                        <textarea className='form-control' maxLength={200} name="profile_heading" value={isChanged?.profile_heading ? formData?.profile_heading : profileData?.profile_heading } onChange={handleInputChange}></textarea>
                    </div>
                    <div className='form-group'>
                        <label htmlFor="">Profile Summary <strong class="fw-normal">(character limit :1000)</strong></label>
                        <textarea className='form-control summary' maxLength={1000} name="profile_summary" value={isChanged?.profile_summary ? formData?.profile_summary : profileData?.profile_summary} onChange={handleInputChange}></textarea>
                    </div>
                    <div className='form-group'>
                        <label htmlFor="">Most Unique Thing <strong class="fw-normal">(character limit :200)</strong></label>
                        <textarea className='form-control' maxLength={200} name="most_unique_thing" value={isChanged?.most_unique_thing ? formData?.most_unique_thing : profileData?.most_unique_thing} onChange={handleInputChange}></textarea>
                    </div>
                    <div className='form-group placholder'>
                        <label htmlFor="">Skills</label>
                        {/* <input type="text" className='form-control' placeholder='' /> */}
                        <div onFocus={() => initialFetch("skillSetList","skillSetList")}>
                         <Multiselect
                                          id="skillSetList" 
                                          isObject={false}
                                          onRemove={handleSkillsRemove}
                                        //   selectionLimit={3}
                                          onSelect={(item) => handleSkillsSelect(item)}
                                          onSearch={(val) => setSkillsSearch(val)}
                                          placeholder='Type 3+ characters to search'
                                          options={skillsResults?.map((item) => item.object_name) || []}
                                          selectedValues={formData.skillSetList || prefillData.skillSetList ||[]}
                                        /></div>
                    </div>

                    <div className="form-group placholder">
  <label htmlFor="current_state">Home State</label>
  <div className="position-relative" ref={stateRef}>
    <input
      type="text"
      name="home_state"
      className="form-control bg-white mb-3"
      placeholder="Type 3+ characters to search"
      onFocus={()=> initialFetch("nativeState","nativeState")}
      value={isChanged.state ? state : profileData?.home_state || ""}
      onChange={(e) => {
        const value = e.target.value;
        setState(value);
        setIsChanged((prev) => ({ ...prev, state: true }));
        setStateSearch(value);
      }}
    />
    {stateSearchResults && stateSearchResults.length > 0 && (
      <ul 
        className="list-group position-absolute w-100" 
        style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000, top: '100%' }}
      >
        {stateSearchResults.map((item, idx) => {
          return (
            <li 
              key={idx} 
              className="list-group-item list-group-item-action" 
              onClick={() => {
                setFormData(prev => ({ ...prev, native_state: item.object_id }));
                setState(item.object_name);
        setIsChanged((prev) => ({ ...prev, state: true }));
        dispatch({ type: RESET_SEARCH });
                setStateSearch('');
              }}
              style={{ cursor: 'pointer' }}
            >
              {item.object_name}
            </li>
          );
        })}
      </ul>
    )}
  </div>
</div>
           
           
                    <div className="form-group placholder">
  <label htmlFor="current_city">Home City</label>
  <div className="position-relative" ref={cityRef}>
    <input
      type="text"
      name="home_city"
      className="form-control bg-white mb-3"
      placeholder="Type 3+ characters to search"
      onFocus={() => initialFetch("homeCity","homeCity")}
      value={isChanged.city ? city : profileData?.home_city || ""}
      onChange={(e) => {
        const value = e.target.value;
        setCity(value);
        setIsChanged((prev) => ({ ...prev, city: true }));
        setCitySearch(value);
      }}
    />
    {citySearchResults && citySearchResults.length > 0 && (
      <ul 
        className="list-group position-absolute w-100" 
        style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000, top: '100%' }}
      >
        {citySearchResults.map((item, idx) => {
          return (
            <li 
              key={idx} 
              className="list-group-item list-group-item-action" 
              onClick={() => {
                setFormData(prev => ({ ...prev, native_city: item.object_id }));
                setCity(item.object_name);
        setIsChanged((prev) => ({ ...prev, city: true }));
        dispatch({ type: RESET_SEARCH });
                setCitySearch('');
              }}
              style={{ cursor: 'pointer' }}
            >
              {item.object_name}
            </li>
          );
        })}
      </ul>
    )}
  </div>
</div>

                </div>
            </div>
        </div>
        <div className="btn-footer">
            <div className="container-fluid d-flex justify-content-lg-end">
              <button className='default-btn default-border bg-transparent back-btn me-3' onClick={() => setCurrentStep(4)}><img src="./images/back-arrow.png"  className='d-block d-md-none'/><span className='d-none d-md-block'>Back</span></button>
                <button className='default-btn default-border bg-transparent me-3' onClick={() => setCurrentStep(6)}>Skip</button>
                <button className='default-btn' onClick={handleSaveAndNext}>Save & Next</button>
            </div>
        </div>
   </>
  )
}

export default ProfileSummary